import { cn } from '@shared/lib/cn';

export interface TabsSkeletonProps {
  /** 탭 막대 수. 기본 3(Figma) */
  count?: number;
  /** 패널 자리의 글자 막대 3줄을 그릴지. 기본 true */
  showPanel?: boolean;
  className?: string;
}

/**
 * Tabs 의 status=init — 탭 자리마다 56×12 막대(좌우 16), 아래에 글자 막대 3줄.
 * 56 = `size.skeleton.56`(DD-19).
 */
export function TabsSkeleton({ count = 3, showPanel = true, className }: TabsSkeletonProps) {
  return (
    <div
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', 'flex flex-col gap-4', className)}
    >
      <div className="flex border-b border-border-subtle">
        {Array.from({ length: count }, (_, index) => (
          <span key={index} className="flex h-(--size-control-md) items-center px-4">
            <span className="h-3 w-(--size-skeleton-56) rounded-full bg-bg-pressed" />
          </span>
        ))}
      </div>
      {showPanel ? (
        <div className="flex w-11/12 flex-col gap-2">
          <span className="h-3 w-full rounded-full bg-bg-pressed" />
          <span className="h-3 w-full rounded-full bg-bg-pressed" />
          <span className="h-3 w-3/5 rounded-full bg-bg-pressed" />
        </div>
      ) : null}
    </div>
  );
}
